export const EMERGENCY_CONTACT_NUMBER = "0508 832 867";
